import { routes } from './testemunhos.routes';
import ForListTestemunhosController from "./directory/directory.controller";
export default angular.module('app.formacao.testemunhos', [])
    .config(routes)
    .controller('ForListTestemunhosController', ForListTestemunhosController)
    .name;
